// extracted by mini-css-extract-plugin
module.exports = {"container":"conferences_container__2oWcX","confDate":"conferences_confDate__3bAAq","confItem":"conferences_confItem__12c-I","tabNav":"conferences_tabNav__1YipV"};